module.exports = __webpack_public_path__ + "static/media/24-lave.96e2472e.mp3";